import Vue from 'vue';
import Router from 'vue-router';

import store from './store';
import Auth from './views/Auth.vue';
import Map from './views/Map.vue';
import Panorama from './views/Panorama.vue';
import Profile from './views/Profile.vue';


Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        { path: '/', component: Map },
        {
            path: '/auth',
            component: Auth,
            beforeEnter: async (to, from, next) => {
                await Vue.nextTick();
                const { getters: { isAuthorized } } = store;

                if (isAuthorized) {
                    next('/profile');
                } else {
                    next();
                }
            },
        },

        {
            path: '/panorama',
            component: Panorama,

            /**
             * Check if the panorama is set and user has
             * permissions before displaying Panorama
             * component, otherwise redirect to Map.
             */
            beforeEnter: async (_, __, next) => {
                await Vue.nextTick();
                const {
                    state: { panorama: { panorama } },
                    getters: { 'permissions/panoramasPermission': permission },
                } = store;

                if (!panorama || !permission) {
                    next('/');
                    return;
                }

                next();
            },
        },
        { path: '/profile', component: Profile },
    ],
});

router.beforeEach(async (to, from, next) => {
    await Vue.nextTick();
    const { getters: { isAuthorized } } = store;

    if (to.path !== '/auth') {
        if (!isAuthorized) {
            next({ path: '/auth', replace: true });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
